import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-navbar-primary',
  imports: [RouterLink],
  template: `
    <nav
      class="navbar navbar-expand-lg navbar-light fixed-top bg-body-tertiary"
    >
      <div class="container">
        <a class="navbar-brand" routerLink="/">
          <img src="/assets/img/navbar_logo.svg" alt="" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.facebook.com/profile.php?id=61568128125045"
                aria-label="Facebook"
                target="_blank"
                rel="noopener"
              >
                <img src="/assets/icons/facebook.svg" alt="" />
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://x.com/UDEP_Puebla"
                aria-label="Twitter"
                target="_blank"
                rel="noopener"
              >
                <img src="/assets/icons/x.svg" alt="" />
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.instagram.com/udep_puebla/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener"
              >
                <img src="/assets/icons/instagram.svg" alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  `,
  styles: `
    .navbar-nav {
      --bs-nav-link-padding-x: 1rem;
      flex-direction: row;
      justify-content: center;
    }
  `
})
export class NavbarPrimaryComponent {}
